import React, { useState } from "react";
import { Link, } from "react-router-dom";
import language from "../../../libraries/label-lang";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import useFetch from "../../../hooks/useFetch";
import Api from '../../../libraries/api';
import { toast, ToastContainer } from 'react-toastify';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import NumberFormat from 'react-number-format';

const mapStateToProps = (state) => {
      return {
            toggle_set_lang: state.toggle_set_lang,
      };
};

export default connect(mapStateToProps)((props) => {
      const LANG = props.toggle_set_lang === "indo" ? language.id : language.en;
      const page_id = props.history.location.pathname.split("/")[3];

      const url = `/products/${page_id}`;
      const { data: fetchData, isLoading } = useFetch(url);
      const data = fetchData;

      const [showDialog, setDialog] = useState(false)
      const [loading, setLoading] = useState(false)
      const handleDelete = _ => {

            setLoading(true)
            Api.delete(`/products/${page_id}`)
                  .then(res => {
                        props.history.push('/products', {
                              msg: 'deleted'
                        })
                  })
                  .catch(e => {
                        setDialog(false)
                        setLoading(false)
                        showMessage(false, e.toString())
                  })
      }

      const showMessage = (status, message) => {
            if (status) {
                  toast.success(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                  });
            } else {
                  toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                  });
            }
      };

      return (

            <div className="dashboard-detail">
                  <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                              <li className="breadcrumb-item">
                                    <Link to="/">{LANG.label_dashboard}</Link>
                              </li>
                              <li className="breadcrumb-item">
                                    <Link to="/products">{LANG.label_products}</Link>
                              </li>
                              <li className="breadcrumb-item active" aria-current="page">
                                    Detail {LANG.label_products}
                              </li>
                        </ol>
                  </nav>
                  <h2 className="text-uppercase ">detail {LANG.label_products}</h2>
                  <div className="w-50 bg-white p-3 mt-2" style={{ borderRadius: 10 }}>
                        {(isLoading || loading) && (
                              <div className="d-inline-flex justify-content-center align-items-center w-100 p-3">
                                    <CircularProgress />
                              </div>
                        )}
                        {data && (
                              <>
                                    <div className="d-inline-flex justify-content-center w-100 " >
                                          <img alt='' src={`https://freshfactory-assets.s3.ap-southeast-1.amazonaws.com/${data.image}`}
                                                style={{ width: 200, background: `lightgrey` }} />
                                    </div>
                                    <Section>
                                          <h5>{data.skuNumber}</h5>
                                          <h3 className='my-2'>{data.name}</h3>
                                    </Section>
                                    <Section>
                                          <Rowing
                                                title={LANG.label_storage}
                                                value={data.storage}

                                          />
                                          <Rowing
                                                title={LANG.label_category}
                                                value={data.category}

                                          />
                                          <Rowing
                                                title={LANG.label_locker}
                                                value={data.lockerSize && data.lockerSize.name}

                                          />
                                          <Rowing
                                                title={LANG.label_packaging}
                                                value={data.supliedPackaging}
                                          />
                                          <Rowing
                                                title={LANG.label_size || 'Ukuran Loker'}
                                                value={`${data.length} x ${data.width} x ${data.height}`}
                                          />

                                          <Rowing
                                                title={LANG.label_weight}
                                                value={data.weight}
                                          />

                                    </Section>

                                    <Section>
                                          {/* incomplete api */}

                                          <Rowing
                                                title={LANG.label_expired}
                                                value={data.shelfLife +' '+LANG.label_days}
                                          />

                                          <Rowing
                                                price
                                                title={LANG.label_product_price || 'Harga Produk'}
                                                value={<NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={parseFloat(data.price)} decimalScale={0} displayType={'text'}  fixedDecimalScale={false}renderText={value => value} />}
                                          />

                                    </Section>

                                    {/* missing api */}
                                    <Rowing
                                          title={LANG.label_product_desc}
                                          value={data.description}

                                    />

                                    <div className='d-inline-flex w-100 justify-content-between mt-5'>
                                          <Button
                                                variant='contained'
                                                color='secondary'
                                                className='float-right mb-3'
                                                onClick={_ => setDialog(true)}
                                          >
                                                {LANG.button_delete}
                                          </Button>
                                         {/* <Button
                                                variant='contained'
                                                color='secondary'
                                                className='float-right mb-3'
                                                onClick={() => {
                                                      props.history.push('/products/edit/' + page_id)
                                                }}
                                          >
                                                {LANG.button_edit}
                                          </Button>*/}
                                    </div>

                              </>
                        )}
                  </div>
                  <Dialog
                        maxWidth='sm'
                        fullWidth={true}
                        open={showDialog}
                        onClose={_ => setDialog(false)}
                        aria-labelledby='form-dialog-title'>
                        <DialogTitle id='form-dialog-title'>Anda yakin ingin menghapus produk:</DialogTitle>

                        <DialogActions>
                              <Button
                                    variant='contained'
                                    className='mr-3'
                                    onClick={_ => setDialog(false)}
                              >
                                    {LANG.button_cancel}
                              </Button>
                              <Button
                                    variant='contained'
                                    color='primary'
                                    className=''
                                    onClick={handleDelete}
                                    disabled={loading && 'disabled'}
                              >
                                    {LANG.button_delete}{loading && <i className='fa fa-spinner fa-spin'> </i>}
                              </Button>
                        </DialogActions>
                  </Dialog>

                  <ToastContainer />

            </div>
      );
});

const Section = ({ children }) => <div className='pb-2' style={{ borderBottom: `1px solid lightgrey` }}>{children}</div>

const Rowing = ({ title, value, price }) => (

      <div className='row m-0 py-2 mt-1'>
            <div className='col-4 p-0' style={{ color: '#419ad2' }}>{title}</div>
            <div className='col-8'>: {price ? 'Rp.' : ''} {value}</div>
      </div>
)


